<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';

    import ButtonSmallBlueRounded from '../../../../shared/ButtonSmallBlueRounded.svelte';
    import type { RouteSummaryDataRouteTypeType } from './RouteSummaryData';
    import MessageInline from '../../../../shared/Messages/MessageInline.svelte';
    import ErrorInline from '../../../../shared/ErrorInline.svelte';
    import WarningInline from '../../../../shared/WarningInline.svelte';
    import RouteSummaryRow from './RouteSummaryRow.svelte';
    import { debug, deliveryList } from '../../../../../stores/store';
    import { AssignmentApi } from '../../AssignmentApi';
    import { api } from '../../../../../stores/api';
    import { Assignment } from '../../Assignment';
    import { rsa } from './rsa';
    import './RouteSummary.css';
    import { features } from '../../../../shared/Features/features';
    import DownloadDeliveryList from '../../PageScenario/DownloadDeliveryList.svelte';

    export let assignment: Assignment;
    export let tabRoute: boolean;
    export let onChange: (routeType: RouteSummaryDataRouteTypeType) => void;
    export let disabled: boolean = false;
    export let switchableRoutes: boolean = true;

    const noValueChar: string = '-';
    const scale: number = 0.6;

    export let loading: boolean;
    let actionInProgress: boolean = false;
    let vehicle = assignment.getVehicle();

    $rsa.setRowsVisibility(assignment, tabRoute);

    const onChangeRow = (routeType: RouteSummaryDataRouteTypeType) => {
        $rsa.setRowsVisibility(assignment, tabRoute, routeType);
        onChange($rsa.selectedRouteType);
        console.log('onChangeRow', $rsa.selectedRouteType);
    };

    $: {
        $rsa.setRowsVisibility(assignment, tabRoute, $rsa.selectedRouteType, false);
    }

    $: {
        loading = actionInProgress;
        // loading = $rsa.isLoading() || actionInProgress;
        console.log('RouteSummary, loading', loading);
    }

    $: {
        let _vehicle = assignment.getVehicle();
        if ((vehicle?.id ?? 0) !== (_vehicle?.id ?? 0)) {
            vehicle = _vehicle;
            $rsa.reload(assignment);
        }
    }
</script>

<div
    style="display: flex; flex-direction: column; justify-content: flex-end; row-gap: 8px; min-height: 60px;
justify-content: flex-start;"
>
    <div class="route-summary feature_rebuild_route_summary">
        {#if $debug}
            comparable:{$rsa.isBaseRouteComparable() ? 'TRUE' : 'FALSE'}
        {/if}
        <div class="route-summary-row">
            <div class="_checkbox"></div>
            <div class="desc lite">{$_('Jobs')}</div>
            <!--            <div class="time lite">-->
            <!--                {$_('Time')}-->
            <!--            </div>-->
            <!--            <div class="distance lite">-->
            <!--                {$_('Distance')}-->
            <!--            </div>-->
            <!--            <div class="deliveries lite">{$_('Quantity of deliveries')}</div>-->
            <!--            <div class="price lite">{$_('Cost')}</div>-->
            <div class="deliveries lite">{$_('Quantity of stops')}</div>
            <div class="price lite">{$_('Distance')}, {$_('Time')}, {$_('Cost')}</div>
        </div>

        {#if $rsa.getCurrentRoute().visible}
            <RouteSummaryRow
                {disabled}
                route={$rsa.getCurrentRoute()}
                {loading}
                bind:actionInProgress
                {scale}
                bind:assignment
                {noValueChar}
                bind:selectedRouteType={$rsa.selectedRouteType}
                showCheckbox={true}
                checkboxDisabled={!switchableRoutes}
                onChange={onChangeRow}
            />
        {/if}
        {#if $rsa.getBaseRoute().visible}
            {#if $rsa.getCurrentRoute().visible}
                <div class="separator-summary"></div>
            {/if}
            <RouteSummaryRow
                {disabled}
                route={$rsa.getBaseRoute()}
                {scale}
                {loading}
                bind:actionInProgress
                bind:assignment
                {noValueChar}
                bind:selectedRouteType={$rsa.selectedRouteType}
                showCheckbox={true}
                checkboxDisabled={$deliveryList.isRouteVariantVisible || !switchableRoutes}
                onChange={onChangeRow}
            />
        {/if}
        {#if $rsa.getModifiedByOperatorRoute().visible}
            {#if $rsa.getCurrentRoute().visible || $rsa.getBaseRoute().visible}
                <div class="separator-summary"></div>
            {/if}
            <RouteSummaryRow
                {disabled}
                route={$rsa.getModifiedByOperatorRoute()}
                {scale}
                loading={loading || $rsa.getModifiedByOperatorRoute().isLoading}
                bind:actionInProgress
                bind:assignment
                {noValueChar}
                bind:selectedRouteType={$rsa.selectedRouteType}
                italicStyle={true}
                checkboxDisabled={!switchableRoutes}
                onChange={onChangeRow}
            />
        {/if}
        {#if !$rsa.tabRoute || $rsa.getToConfirmRoute().visible}
            {#if $rsa.getCurrentRoute().visible || $rsa.getBaseRoute().visible}
                <div class="separator-summary"></div>
            {/if}
            <RouteSummaryRow
                {disabled}
                hidden={!$rsa.getToConfirmRoute().visible}
                route={$rsa.getToConfirmRoute()}
                {scale}
                {loading}
                bind:actionInProgress
                bind:assignment
                {noValueChar}
                bind:selectedRouteType={$rsa.selectedRouteType}
                checkboxDisabled={!switchableRoutes}
                onChange={onChangeRow}
            />
        {/if}
        {#if !$rsa.tabRoute || $rsa.getToAssignRoute().visible}
            {#if $rsa.getCurrentRoute().visible || $rsa.getBaseRoute().visible || $rsa.getToConfirmRoute().visible}
                <div class="separator-summary"></div>
            {/if}
            <RouteSummaryRow
                {disabled}
                route={$rsa.getToAssignRoute()}
                hidden={!$rsa.getToAssignRoute().visible}
                {scale}
                {loading}
                bind:actionInProgress
                bind:assignment
                {noValueChar}
                bind:selectedRouteType={$rsa.selectedRouteType}
                checkboxDisabled={!switchableRoutes}
                onChange={onChangeRow}
            />
        {/if}
    </div>

    <div style="display: flex; justify-content: flex-end; column-gap: 10px; row-gap: 5px;">
        {#if assignment.isDefault() && !assignment.getVehicle()?.route_optimize && assignment.hasVehicleAssigned()}
            <div class="no-route-trace">{$_('Routing_off_for_vehicle')}</div>
        {/if}
        {#if assignment.isDownloaded()}
            {#if assignment.isRouteModifiedByDriver()}
                <MessageInline text={$_('Route modified by driver')} opacity={1} />
                <!--{:else if assignment.isRouteModifiedAfterDownload()}-->
                <!--    <MessageInline text={$_('route_changes_waiting_for_acceptance')} opacity={1} />-->
            {:else}
                <MessageInline text={$_('route_downloaded')} />
            {/if}
        {:else if assignment.isLocked()}
            {#if assignment.isRouteModifiedAfterDownload()}
                <MessageInline text={$_('route_changes_waiting_for_acceptance')} opacity={1} />
            {:else}
                <MessageInline text={$_('route_locked')} />
            {/if}
        {/if}
        {#if assignment.isRouteCalculationFailed()}
            <ErrorInline text={$_('Route failed')} />
        {/if}
        {#if assignment.isComparative()}
            <WarningInline text={$_('Route_comparative')}/>
        {/if}
        {#if !assignment.isComparative() && assignment.isRouteCalculated()}
            <DownloadDeliveryList assignmentId={assignment.getId()} scenarioId={assignment.getScenarioId()}/>
        {/if}
    </div>
    {#if $debug}
        <ButtonSmallBlueRounded
            text="Simulate download route by driver"
            disabled={!assignment.isRouteCalculated() ||
                assignment.isDownloaded() ||
                !assignment.isLocked()}
            on:click={() => {
                AssignmentApi.setRouteDownloaded(get(api), assignment.getId()).then(res => {
                    if (res) assignment.set(res);
                    assignment = assignment;
                });
            }}
        />
        <ButtonSmallBlueRounded
            text="Simulate download route by driver (without refresh)"
            disabled={!assignment.isRouteCalculated() ||
                assignment.isDownloaded() ||
                !assignment.isLocked()}
            on:click={() => {
                AssignmentApi.setRouteDownloaded(get(api), assignment.getId()).then(res => {});
            }}
        />
    {/if}
</div>
